import { render, staticRenderFns } from "./xkRanking.vue?vue&type=template&id=277fdce7&scoped=true&"
import script from "./xkRanking.vue?vue&type=script&lang=js&"
export * from "./xkRanking.vue?vue&type=script&lang=js&"
import style0 from "./xkRanking.vue?vue&type=style&index=0&id=277fdce7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fdce7",
  null
  
)

export default component.exports